/* =============================================================
   🧠 TOURNAMENT SELECTORS
============================================================= */

export const selectTournamentsState = (state) =>
  state.admin?.tournaments || {};

export const selectTournamentList = (state) =>
  selectTournamentsState(state).list || [];

export const selectTournamentLoading = (state) =>
  selectTournamentsState(state).loading || false;

export const selectTournamentError = (state) =>
  selectTournamentsState(state).error || null;

/* 🎯 Get categories by tournament ID */
export const selectCategoriesByTournament = (tournamentId) => (state) => {
  const tournaments = selectTournamentList(state);
  const t = tournaments.find((t) => t.id == tournamentId);
  return t?.categories || [];
};

/* 🎯 Get single tournament */
export const selectTournamentById = (tournamentId) => (state) => {
  const tournaments = selectTournamentList(state);
  return tournaments.find((t) => t.id == tournamentId) || null;
};